import {
	GET_MEMBERSHIP_USERS,
	GET_MEMBERSHIP_USERS_DETAILS,
	UPDATE_MEMBERSHIP_USER,
} from '../../Actions/Admin/ManageMembershipUserActions';

const initialState = {
	allMemberships: [],
	membershipUsersDetails:[]
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_MEMBERSHIP_USERS:
			return {
				...state,
				loading: true,
				membershipUsers: action.payload
			};
		case GET_MEMBERSHIP_USERS_DETAILS:
			return{
				...state,
				membershipUsersDetails: action.payload
			}
		case UPDATE_MEMBERSHIP_USER:
			return {
				...state,
				membershipUsers: action.payload
			};
		default:
			return state;
	}
};
